(ns iris.cookie
  (:require
   [re-frame.core :as re-frame]
   [goog.net.Cookies :as Cookies]
   [clojure.string :as str]))


(def cookies (Cookies/getInstance))

;; TODO: is cookie-set-effect needed??
(re-frame/reg-fx
 :cookie/set
 (fn cookie-set-effect [options]
   (.set cookies (:name options) (:value options) (clj->js {:maxAge (:max-age options) :path (:path options)}))))


(re-frame/reg-fx
 :cookie/remove
 (fn [options]
   (.remove cookies (:name options))))


(re-frame/reg-cofx
 :cookie/get
 (fn [cofx name]
   (assoc cofx (keyword name) (.get cookies name))))


;; (re-frame/reg-event-fx
;;   ::get-jwt
;;   ;; (fn [cofx e [_ query-params]]
;;   [(re-frame/inject-cofx :cookie/get "jwt")]
;;   (fn [{:keys [db] :as cofx} [e]]
;;     (println "cofx::" cofx)
;;     ))


(re-frame/reg-event-fx
 ::set
 (fn [e [_ options]]
   {:cookie/set options}))


(re-frame/reg-event-fx
 ::remove
 (fn [e [_ options]]
   {:cookie/remove options}))


(defn get-cookie [name]
  (.get cookies name))

(defn remove-cookie [name path]
  (.remove cookies name path (.. js/window -location -hostname)))

(defn remove-base-domain-cookie [name path]
  (let [base-domain (->> (str/split (.. js/window -location -hostname) #"\.")
                         (take-last 2)
                         (str/join "."))]
    (.remove cookies name path base-domain)))


(defn set-cookie [name value max-age path]
  (deftype Options [domain maxAge path sameSite secure])
  (let [options (Options.
                 (.. js/window -location -hostname)
                 max-age
                 path
                 "strict"
                 (if (= (.. js/window -location -hostname) "localhost") false true))]
    (.set cookies name value options)))